/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: TerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { TerritoriesData, TerritoriesService } from './Territories.service';
import { TerritoriesSearchComponent }  from './TerritoriesSearch.component';

@Component({
	selector: 'my-Territories',
	template: require('./TerritoriesList.component.html'),
	providers: [TerritoriesService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class TerritoriesListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	TerritoriesList: TerritoriesData[];
	newTerritories: TerritoriesData;
	selectedTerritories: TerritoriesData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(TerritoriesSearchComponent) filterComponent: TerritoriesSearchComponent;

	sortExpression: string = "TerritoryID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private TerritoriesService: TerritoriesService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newTerritories = new TerritoriesData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.TerritoriesService.getAll().subscribe(record => this.TerritoriesList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getTerritoriesByPaging();

		/*
		this.TerritoriesList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getTerritories() {
		this.TerritoriesService.getAll()
			.subscribe(data => this.TerritoriesList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on TerritoriesSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getTerritoriesByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getTerritoriesByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getTerritoriesByPaging();
	}
	
	// Get records by paging
	getTerritoriesByPaging() {
		this.TerritoriesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.TerritoriesList=data.TerritoriesList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addTerritories() {
		this.TerritoriesService.addTerritoriesData(this.newTerritories).subscribe(record => console.log(record));
		this.getTerritories();
	}

	// Updates existing record
	updateTerritories() {
		this.TerritoriesService.updateTerritoriesData(this.selectedTerritories).subscribe(record => console.log(record));
		this.getTerritories();
	}

	// Deletes record with specified id
	deleteTerritories(id: string) {
		if (window.confirm('Are you sure you want to delete this Territories?') == true)
		{
			this.TerritoriesService.deleteTerritories(id)
			.subscribe(data => this.getTerritories(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Territories record deleted successfully...', 'Delete Territories');
					console.log('Territories record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getTerritoriesByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getTerritoriesByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getTerritoriesByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getTerritoriesByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: TerritoriesData) {
		this.router.navigate(['/Territories', item.TerritoryID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: TerritoriesData) {
		this.router.navigate(['/Territories/Details', item.TerritoryID]);
	}

	// Set record as selected
	SelectTerritories(item: TerritoriesData) {
		this.selectedTerritories = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Territories/TerritoriesList.component.ts